export const LIVE_CAMS_URL = 'https://api.cam4.com/directoryCams?online=true&gender=female&directoryJson=true&resultsPerPage=5&page=1';
export const SNAPSHOTS_CDN = 'https://snapshots.xcdnpro.com/thumbnails/';
